import React from 'react';

import SidebarIconButton from './SidebarIconButton';

interface GoToFlowchartButtonProps {
  onClick: () => void;
}

/** @package */
export default function GoToFlowchartButton({onClick}: GoToFlowchartButtonProps): JSX.Element {
  return (
    <SidebarIconButton
      tooltip="Go to flowchart"
      onClick={onClick}
      ariaLabel="Go to flowchart"
      dataTestComponent="GoToFlowchartButton"
      icon="crosshairs"
    />
  );
}
